import { Divider } from '@mantine/core';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import HeaderComponent from '../Header/HeaderComponent';
import Sidebar from '../sidebar/Sidebar';
import styles from './DashboardWrapper.module.css';

type DashboardWrapperProps = {
  heading: string;
  children: any;
  rightHeaderComponent?: React.ReactNode;
};

export default function DashboardWrapper({ heading, children, rightHeaderComponent }: DashboardWrapperProps) {
  const location = useLocation();
  const isSubmissionsPage = location.pathname === '/dashboard/submissions';
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 998);

  return (
    <div className={styles.dashboardWrapper}>
      <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className={styles.mainSection}>
        <HeaderComponent heading={heading} setShowSidebar={setShowSidebar} rightContent={rightHeaderComponent} />
        {isSubmissionsPage && <Divider />}
        <div className={styles.variableSection}>{children}</div>
      </div>
    </div>
  );
}
